import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PlusIcon, MessageSquareIcon, ThumbsUpIcon, UserIcon, ClockIcon, PlayIcon, StarIcon, TrendingUpIcon, BookOpenIcon, ShoppingBagIcon } from 'lucide-react';
export function CommunityHubPage() {
  const {
    tab
  } = useParams<{
    tab: string;
  }>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'discussions' | 'plays' | 'tutorials' | 'marketplace'>('discussions');
  useEffect(() => {
    if (tab) {
      setActiveTab(tab as any);
    }
  }, [tab]);
  const handleTabChange = (newTab: string) => {
    setActiveTab(newTab as any);
    navigate(`/community/${newTab}`);
  };
  const discussions = [{
    id: 1,
    title: 'Best practices for intent-based outreach?',
    author: 'Sarah Chen',
    avatar: 'SC',
    replies: 12,
    likes: 24,
    time: '2 hours ago',
    category: 'Best Practices'
  }, {
    id: 2,
    title: 'How to measure ABM program success',
    author: 'Mike Johnson',
    avatar: 'MJ',
    replies: 8,
    likes: 15,
    time: '5 hours ago',
    category: 'Metrics'
  }, {
    id: 3,
    title: 'Integrating ZoomInfo with Salesforce - tips?',
    author: 'Emily Rodriguez',
    avatar: 'ER',
    replies: 18,
    likes: 32,
    time: '1 day ago',
    category: 'Integrations'
  }, {
    id: 4,
    title: 'AI-powered personalization strategies',
    author: 'David Park',
    avatar: 'DP',
    replies: 6,
    likes: 11,
    time: '2 days ago',
    category: 'AI & Automation'
  }];
  const communityPlays = [{
    id: 1,
    title: 'Event Follow-up Blitz',
    author: 'Jessica Williams',
    downloads: 156,
    rating: 4.8,
    stage: 'Engagement'
  }, {
    id: 2,
    title: 'Executive Nurture Sequence',
    author: 'Robert Chen',
    downloads: 203,
    rating: 4.9,
    stage: 'Awareness'
  }, {
    id: 3,
    title: 'Product Usage Expansion',
    author: 'Maria Garcia',
    downloads: 89,
    rating: 4.6,
    stage: 'Expansion'
  }, {
    id: 4,
    title: 'Renewal Risk Recovery',
    author: 'Thomas Anderson',
    downloads: 124,
    rating: 4.7,
    stage: 'Commit'
  }];
  const tutorials = [{
    id: 1,
    title: 'Getting Started with GTM Studio',
    duration: '12:34',
    views: 2456,
    thumbnail: '🎯'
  }, {
    id: 2,
    title: 'Building Your First Play',
    duration: '18:45',
    views: 1823,
    thumbnail: '🎬'
  }, {
    id: 3,
    title: 'Advanced Segmentation Techniques',
    duration: '24:12',
    views: 1567,
    thumbnail: '📊'
  }, {
    id: 4,
    title: 'Copilot Agents Deep Dive',
    duration: '15:30',
    views: 3102,
    thumbnail: '🤖'
  }];
  const marketplaceItems = [{
    id: 1,
    title: 'Enterprise ABM Playbook',
    author: 'ZoomInfo',
    price: 'Free',
    rating: 4.9,
    downloads: 1203,
    type: 'Playbook'
  }, {
    id: 2,
    title: 'Intent Signal Templates',
    author: 'Community Pro',
    price: '$49',
    rating: 4.7,
    downloads: 456,
    type: 'Templates'
  }, {
    id: 3,
    title: 'Sales Automation Toolkit',
    author: 'GTM Experts',
    price: '$99',
    rating: 4.8,
    downloads: 789,
    type: 'Toolkit'
  }, {
    id: 4,
    title: 'Email Copy Library',
    author: 'Content Masters',
    price: 'Free',
    rating: 4.6,
    downloads: 2341,
    type: 'Content'
  }];
  return <div className="w-full h-screen flex flex-col bg-gray-50" data-id="element-4508">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-4 lg:px-6 py-3 lg:py-4" data-id="element-4509">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4" data-id="element-4510">
          <div data-id="element-4511">
            <h1 className="text-xl lg:text-2xl font-bold text-gray-900" data-id="element-4512">
              Community Hub
            </h1>
            <p className="text-xs lg:text-sm text-gray-600 mt-1" data-id="element-4513">
              Connect, learn, and share GTM strategies with the community
            </p>
          </div>
          <button className="flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm" data-id="element-4514">
            <PlusIcon className="w-4 h-4" data-id="element-4515" />
            <span data-id="element-4516">Submit Play</span>
          </button>
        </div>
      </div>
      {/* Tabs */}
      <div className="bg-white border-b border-gray-200 px-4 lg:px-6 overflow-x-auto" data-id="element-4517">
        <div className="flex gap-4 lg:gap-6 min-w-max" data-id="element-4518">
          {[{
          id: 'discussions',
          label: 'Discussions',
          icon: MessageSquareIcon
        }, {
          id: 'plays',
          label: 'Community Plays',
          icon: BookOpenIcon
        }, {
          id: 'tutorials',
          label: 'Video Tutorials',
          icon: PlayIcon
        }, {
          id: 'marketplace',
          label: 'Marketplace',
          icon: ShoppingBagIcon
        }].map(tabItem => {
          const Icon = tabItem.icon;
          return <button key={tabItem.id} onClick={() => handleTabChange(tabItem.id)} className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === tabItem.id ? 'border-red-600 text-red-600' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-4519">
                <Icon className="w-4 h-4" data-id="element-4520" />
                <span className="hidden sm:inline" data-id="element-4521">{tabItem.label}</span>
              </button>;
        })}
        </div>
      </div>
      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4 lg:p-6" data-id="element-4522">
        {activeTab === 'discussions' && <div className="max-w-5xl mx-auto space-y-4" data-id="element-4523">
            {discussions.map(discussion => <div key={discussion.id} className="bg-white rounded-lg border border-gray-200 p-4 lg:p-6 hover:shadow-md transition-shadow" data-id="element-4524">
                <div className="flex items-start gap-4" data-id="element-4525">
                  <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center text-red-600 font-semibold flex-shrink-0" data-id="element-4526">
                    {discussion.avatar}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-4527">
                    <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-2" data-id="element-4528">
                      {discussion.title}
                    </h3>
                    <div className="flex flex-wrap items-center gap-3 lg:gap-4 text-xs lg:text-sm text-gray-600" data-id="element-4529">
                      <span className="flex items-center gap-1" data-id="element-4530">
                        <UserIcon className="w-4 h-4" data-id="element-4531" />
                        {discussion.author}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-4532">
                        <MessageSquareIcon className="w-4 h-4" data-id="element-4533" />
                        {discussion.replies} replies
                      </span>
                      <span className="flex items-center gap-1" data-id="element-4534">
                        <ThumbsUpIcon className="w-4 h-4" data-id="element-4535" />
                        {discussion.likes} likes
                      </span>
                      <span className="flex items-center gap-1" data-id="element-4536">
                        <ClockIcon className="w-4 h-4" data-id="element-4537" />
                        {discussion.time}
                      </span>
                    </div>
                    <div className="mt-3" data-id="element-4538">
                      <span className="px-2 py-1 bg-blue-50 text-blue-700 text-xs rounded-full" data-id="element-4539">
                        {discussion.category}
                      </span>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>}
        {activeTab === 'plays' && <div className="max-w-7xl mx-auto" data-id="element-4540">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6" data-id="element-4541">
              {communityPlays.map(play => <div key={play.id} className="bg-white rounded-lg border border-gray-200 p-4 lg:p-6 hover:shadow-lg transition-shadow" data-id="element-4542">
                  <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-2" data-id="element-4543">
                    {play.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-4" data-id="element-4544">By {play.author}</p>
                  <div className="flex items-center justify-between mb-4" data-id="element-4545">
                    <div className="flex items-center gap-1" data-id="element-4546">
                      <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-4547" />
                      <span className="text-sm font-medium text-gray-900" data-id="element-4548">
                        {play.rating}
                      </span>
                    </div>
                    <span className="text-sm text-gray-600" data-id="element-4549">
                      {play.downloads} downloads
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-4550">
                    <span className="px-2 py-1 bg-blue-50 text-blue-700 text-xs rounded-full" data-id="element-4551">
                      {play.stage}
                    </span>
                    <button className="text-sm text-red-600 hover:text-red-700 font-medium" data-id="element-4552">
                      View Play
                    </button>
                  </div>
                </div>)}
            </div>
          </div>}
        {activeTab === 'tutorials' && <div className="max-w-7xl mx-auto" data-id="element-4553">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6" data-id="element-4554">
              {tutorials.map(tutorial => <div key={tutorial.id} className="bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow" data-id="element-4555">
                  <div className="aspect-video bg-gray-100 flex items-center justify-center text-6xl" data-id="element-4556">
                    {tutorial.thumbnail}
                  </div>
                  <div className="p-4" data-id="element-4557">
                    <h3 className="text-base font-semibold text-gray-900 mb-2" data-id="element-4558">
                      {tutorial.title}
                    </h3>
                    <div className="flex items-center justify-between text-sm text-gray-600" data-id="element-4559">
                      <span className="flex items-center gap-1" data-id="element-4560">
                        <ClockIcon className="w-4 h-4" data-id="element-4561" />
                        {tutorial.duration}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-4562">
                        <TrendingUpIcon className="w-4 h-4" data-id="element-4563" />
                        {tutorial.views.toLocaleString()} views
                      </span>
                    </div>
                    <button className="w-full mt-4 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium" data-id="element-4564">
                      Watch Now
                    </button>
                  </div>
                </div>)}
            </div>
          </div>}
        {activeTab === 'marketplace' && <div className="max-w-7xl mx-auto" data-id="element-4565">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6" data-id="element-4566">
              {marketplaceItems.map(item => <div key={item.id} className="bg-white rounded-lg border border-gray-200 p-4 lg:p-6 hover:shadow-lg transition-shadow" data-id="element-4567">
                  <div className="flex items-start justify-between mb-3" data-id="element-4568">
                    <div className="flex-1" data-id="element-4569">
                      <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-1" data-id="element-4570">
                        {item.title}
                      </h3>
                      <p className="text-sm text-gray-600" data-id="element-4571">By {item.author}</p>
                    </div>
                    <span className="px-3 py-1 bg-green-100 text-green-700 text-sm font-semibold rounded-full" data-id="element-4572">
                      {item.price}
                    </span>
                  </div>
                  <div className="flex items-center gap-4 mb-4 text-sm text-gray-600" data-id="element-4573">
                    <div className="flex items-center gap-1" data-id="element-4574">
                      <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-4575" />
                      <span data-id="element-4576">{item.rating}</span>
                    </div>
                    <span data-id="element-4577">{item.downloads} downloads</span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-4578">
                    <span className="px-2 py-1 bg-purple-50 text-purple-700 text-xs rounded-full" data-id="element-4579">
                      {item.type}
                    </span>
                    <button className="text-sm text-red-600 hover:text-red-700 font-medium" data-id="element-4580">
                      View Details
                    </button>
                  </div>
                </div>)}
            </div>
          </div>}
      </div>
    </div>;
}